import React, { Component } from "react";
import axios from 'axios'
import Slider from "react-slick";
import './swipe.css'
import Bannner from '../../static/images/banner.png'

export default class Carousel extends Component {
  constructor(props){
    super(props)
    this.state={
      getBanners:'',
      visible:false,
    }
  }
  componentDidMount(){
    
    this.getBanners()
  
  }
  getBanners(){ 
     const _this = this
     axios.get('/fapi/getAdvPics?kind=1&count=10')
      .then(res=>{
        
        this.setState({
            getBanners:res.data
        })
         
         //console.log(res.data)
     
    })
  
  
  }
  render() {
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      
      autoplay: true,
      autoplaySpeed:10000,
      slidesToScroll: 1,
      arrows:true
     
     
    };
    const bannersData = this.state.getBanners
    return (

      <div className="banner">
        
        <Slider {...settings}>
	         {
               bannersData.data?bannersData.data.map((item,i) =>{

                  const data = bannersData.imghost +''+ item.imgurl                
                  return <div key={i}><a href={item.linkurl} target="_blank"><img src={data} /></a></div>
               }):null
            }
        </Slider>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/component/swiper/index.js